import { render, staticRenderFns } from "./EntityGalleryView.vue?vue&type=template&id=154a2f50&scoped=true"
import script from "./EntityGalleryView.vue?vue&type=script&lang=js"
export * from "./EntityGalleryView.vue?vue&type=script&lang=js"
import style0 from "./EntityGalleryView.vue?vue&type=style&index=0&id=154a2f50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154a2f50",
  null
  
)

export default component.exports